<script>
    let button, ypos;

    function scrollToTop(){

        ypos=0;
    }

</script>


<svelte:window bind:scrollY={ypos}/>
<!-- svelte-ignore a11y-missing-attribute -->
<button on:click={scrollToTop} class="terugnaarboven">
    ^
</button>
<div class="credit">
    <h1>💸</h1>
    <h1><br/>WAT<br/>DE<br/>STUFI?!</h1>
    <p>Een site van <span class="creditlink">Atma Saam</span></p>
    <span>2022</span>
</div>
